// @ts-nocheck
/* eslint-disable */
import SceneMarkerPOI from "./poi";

export default class SceneMarkerWindyWebcam extends SceneMarkerPOI {
	/**
	 * Vytvoreni foto poie.
	 *
	 * @param  {SceneCoords} coords Souradnice
	 * @param  {Number|String} [id] Volitelne ID
	 * @param  {Object} [opts] Volitelny objekt s konfiguraci
	 */
	constructor(scene, itemId, coords?, id?, opts?) {
		super(scene, itemId, coords, id, opts);

		this._m3dData = { type: "wcam" };
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneMarkerWindyWebcam",
			type: "marker"
		};
	}

	/**
	 * Nastaveni markeru z dat.
	 *
	 * @param  {Object} data
	 */
	fromData(data) {
		let options = {
			title: data.title,
		};

		if (data.paid) { options.paid = data.paid; }
		if (data.url) { options.url = data.url; }
		if (data.anchor) { options.anchor = data.anchor; }
		if (data.size) { options.size = data.size; }

		this._coords = this._scene.coordsFromWGS84(data.mark.lon, data.mark.lat);
		this._id = data.id;

		// options merge
		for (let id in options) {
			this._options[id] = options[id];
		}

		this._fromData = data;

		// ostatni data
		this._title = data.title;
		this._source = data.source;
		this._plainId = data.id;
	}
}
